// Module
var code = `<div id="loan-account-information" ng-if="\$ctrl.customFieldCategoryDefinitions.length > 0 || \$ctrl.nonCategoryCustomFields.length > 0">
  <h2 class="section-header section-header--upper-margin">Custom fields</h2>
  <table class="table">
    <tbody class="tbody">
    <tr ng-repeat="definition in \$ctrl.customFieldCategoryDefinitions">
      <td class="label mis-group">{{definition.name}}</td>
      <td class="values mis-group">
        <div class="mis-tree">
          <ent
            tree-data="definition.children"
            ng-model="\$ctrl.selectedCustomFieldCategory[definition.id]"
            ng-change="\$ctrl.selectedProductCategoryChange()"
            node-label="\$ctrl.productCategoryLabel"
            search="true"
            select-only-leaves="true"
            node-visibility="\$ctrl.showOnlyEnabled"
            ng-disabled="!\$ctrl.editModeEnabled()"
            ng-required="definition.required"
          >
          </ent>
        </div>
      </td>
    </tr>
    <tr ng-repeat="field in \$ctrl.nonCategoryCustomFields">
      <td class="label">{{field.name}}:</td>
      <td class="values">
        <input ng-if="field.type === 'TEXT'"
               type="text"
               ng-model="\$ctrl.customFieldValues[field.id]"
               ng-disabled="!\$ctrl.editModeEnabled()"
               maxlength="255"
               ng-required="field.required">
        <input ng-if="field.type === 'NUMBER'"
               type="number"
               step="0.01"
               string-to-number
               ng-model="\$ctrl.customFieldValues[field.id]"
               ng-disabled="!\$ctrl.editModeEnabled()"
               ng-required="field.required">
      </td>
    </tr>
    </tbody>
  </table>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/new-loan/page/details/lai/custom-field-input.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;